/* eslint-disable import/no-anonymous-default-export */
export default [
  {
    id: "0",
    title: "Architecture-company-site-project",
    link: "https://woachkatzl.github.io/Architecture-company-site/",
    template:
      "https://www.figma.com/community/file/891374608655348853/Website-of-architects---free-website",
    text: "Сайт архитектурной компании по макету из Figma. Первый групповой проект  в рамках обучения фронтенд-разработке.",
  },
  {
    id: "1",
    title: "employment-consultant",
    link: "https://lenakokareva81.github.io/employment-consultant/",
    template:
      "https://www.figma.com/file/uLdJMGIHj6pHoUsebNq7fd/Карьерный-консультант-для-экспатов?type=design&node-id=0-1&mode=design",
    text: "Сайт карьерного консультанта для экспатов в Германии. Второй групповой проект в рамках обучения фронтенд-разработке. Макет заказчик не предоставил, разрабатывали самостоятельно.",
  },
  {
    id: "2",
    title: "js-team-project",
    link: "https://otter00.github.io/js-team-project/htmls/main.html#",
    template:
      "https://www.figma.com/file/aXz2MsLlfevUp06BA54AE1/MOVIBE-(Community)?type=design&node-id=0-1&mode=design",
    text: "Киносайт - третий групповой проект в рамках обучения фронтенд-разработке. Первый проект с использованием API и JavaScript.",
  },
  {
    id: "3",
    title: "B2P",
    link: "https://github.com/Ten-Do/B2P",
    template:
      "https://www.figma.com/file/SgHyJ9WM7sfjNTmqqITZel/Test_Best2Pay_?type=design&mode=design",
    text: "Групповой проект в рамках стажировки в компании Best2Pay. По макету предполагалась разработка формы ввода данных клиента и платежной формы с банковскими данными.",
  },
  {
    id: "4",
    title: "Learn English Words",
    link: "https://otter00.github.io/learning-words-game/",
    template: "",
    text: "Четвёртый проект в рамках обучения фронтенд-разработке - проект на React, игра для изучения английских слов в карточках. Имеется функционал добавления, удаления, редактирования отдельного слова. Все слова взяты с индивидуального API.",
  },
  {
    id: "5",
    title: "six-term-project",
    link: "https://otter00.github.io/six-term-project/",
    template:
      "https://otter00.github.io/six-term-project/pages/guide.html - ссылка в обход надоедливой регистрации.",
    text: "Курсовой проект для университета (Проектирование Программных Систем). Основная задача - неработоспособный функционал - реализована посредством надоедливой формы регистрации, цель которой - не дать пользователю легко и спокойно попасть на сайт сервиса, а заставить помучиться с всплывающими окнами, фейковыми кнопками и бесконечной валидацией.",
  },
  {
    id: "6",
    title: "UberEats",
    link: "https://otter00.github.io/UberEats/",
    template:
      "https://www.figma.com/file/8lxQ3PGYTHQsCgTXnEJre8/Uber-Eats?type=design&node-id=0-1&mode=design",
    text: "Самостоятельный проект по завершении изучения вёрстки на курсах от Stepik.org. Предполагалась вёрстка только desktop версии, без использования JavaScript.",
  },
];
